import { useMutation, useQueryClient } from "react-query";

import { WorkspaceCommonParams } from "@interfaces/company/workspace";
import { workspaceQueryKeys } from "./queryKeys";
import { workspaceService } from "@services/workspace-service";

export const useUnarchiveWorkspaceDirectoryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: WorkspaceCommonParams) => workspaceService.unarchiveDirectory(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(workspaceQueryKeys.allDirectoriesFiles);
        queryClient.invalidateQueries("arhived");
      },
    }
  );
};
